module.exports = __webpack_public_path__ + "img/02-japne-cover.86123409.png";